import { render, staticRenderFns } from "./Cita.vue?vue&type=template&id=cb1bd5f8"
import script from "./Cita.vue?vue&type=script&lang=js"
export * from "./Cita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1bd5f8')) {
      api.createRecord('cb1bd5f8', component.options)
    } else {
      api.reload('cb1bd5f8', component.options)
    }
    module.hot.accept("./Cita.vue?vue&type=template&id=cb1bd5f8", function () {
      api.rerender('cb1bd5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Cita.vue"
export default component.exports